import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgQuarterNote = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "_x32_",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 290 825",
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M230.078-0.004v611.078c-23.641-9.969-52.828-14.047-84.422-10.125 c-78.516,9.75-141.969,64.594-141.766,122.407c0.203,57.875,64,96.906,142.469,87.156c78.5-9.766,141.953-64.594,141.75-122.469 V-0.004H340.078z"
	}) })
});
export default SvgQuarterNote;
